import type { NodeId, NodeRecord } from '@ipfabric/utils';
import { produce } from 'immer';

export const makeFilterExistingNodes =
  (nodes: NodeRecord) =>
  (nodeIds: Set<NodeId>): Set<NodeId> =>
    produce(nodeIds, (draft) => {
      for (const nodeId of draft) {
        if (!nodes[nodeId]) {
          draft.delete(nodeId);
        }
      }
    });

export const filterExistingNodes = (
  nodeIds: Set<NodeId>,
  nodes: NodeRecord,
): Set<NodeId> => makeFilterExistingNodes(nodes)(nodeIds);
